module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-144x144-68bace54ef820aa96d2a044f6654d727.png";